export class VideoStoryHTMLElement extends HTMLElement {
    constructor() {
        super();
        this.clickHandler = this.clickHandler.bind(this);
        this.pauseHandler = this.pauseHandler.bind(this);
    }

    private clickHandler(): void {
        const videoFrame = this.querySelector<HTMLIFrameElement>('.video-dam-player').getAttribute('data-player-frame');
        const carouselContainer = this.closest('.carousel-items-container');
        const videoContainer = document.createElement('div');
        videoContainer.innerHTML = videoFrame;
        const closeBtn = this.querySelector<HTMLElement>('.video-dam-player-close').cloneNode(true);
        closeBtn.addEventListener('click', this.closeHandler);
        videoContainer.append(closeBtn);
        // tailwindcss classes MUST be declared in tailwind.config.js safelist or else they MAY be pruned by the build process
        videoContainer.classList.add(...['video-dam-container', 'md:aspect-w-16', 'md:aspect-h-9', 'aspect-w-2', 'aspect-h-3', 'rounded-md']);
        carouselContainer.prepend(videoContainer);
        const iframe = carouselContainer.querySelector<HTMLIFrameElement>('iframe');
        try {
            iframe?.contentWindow.postMessage('PLAY', '*');
        } catch (e) {
            console.error(e);
        }
        carouselContainer.querySelector('.carousel-items').classList.add('hidden');
        (<HTMLElement>this.closest('.carousel').querySelector('.carousel-indicators')).style.display = 'none';
    }

    private closeHandler(): void {
        const carouselContainer = this.closest('.carousel-items-container');
        if (!window.matchMedia('(min-width: 768px)').matches) {
            (<HTMLElement>this.closest('.carousel').querySelector('.carousel-indicators')).style.display = '';
        }
        carouselContainer.querySelector('.video-dam-container')?.remove();
        carouselContainer.querySelector('.carousel-items').classList.remove('hidden');
    }

    private pauseHandler(e: any): void {
        let data: { playerId: string, event: string };
        try {
            data = JSON.parse(e.data);
        } catch {
            return;
        }
        const videoData = this.querySelector('[data-player-frame]')?.getAttribute('data-player-frame');
        if (!videoData?.includes(data.playerId)) {
            // it's someone else's postMessage
            return;
        }
        const carouselContainer = this.closest('.carousel-items-container');
        switch (data.event) {
            // case 'ds-player-pause':
            case 'ds-player-video-ended':
            case 'ds-player-error':
                carouselContainer.querySelector('.video-dam-container')?.remove();
                carouselContainer.querySelector('.carousel-items').classList.remove('hidden');
                if (!window.matchMedia('(min-width: 768px)').matches) {
                    (<HTMLElement>this.closest('.carousel').querySelector('.carousel-indicators')).style.display = '';
                }
                break;
            case 'ds-player-ready': {
                const playerId = JSON.parse(e.data)?.playerId;
                const player = carouselContainer.querySelector<HTMLIFrameElement>(`#${playerId}`);
                try {
                    player?.contentWindow.postMessage('PLAY', '*');
                } catch (e) {
                    console.error(e);
                }
                break;
            }
        }
    }

    public connectedCallback(): void {
        setTimeout(() => {
            this.querySelector('button').addEventListener('click', this.clickHandler);
            window.addEventListener('message', this.pauseHandler);
        });
    }

    public disconnectedCallback(): void {
        this.removeEventListener('click', this.clickHandler);
        this.removeEventListener('click', this.closeHandler);
        window.removeEventListener('message', this.pauseHandler);
    }
}